import React from 'react';
import './SaveButton.scss';

interface SaveButtonProps {
  /** Function to handle save action */
  onSave: () => void;
  /** Custom class name */
  className?: string;
  /** Whether button is disabled */
  disabled?: boolean;
  /** Button label */
  label?: string;
}

/**
 * Generic Save button component
 * Primary action button for saving changes
 */
const SaveButton: React.FC<SaveButtonProps> = ({
  onSave,
  className = '',
  disabled = false,
  label = 'Save'
}) => {
  return (
    <button
      className={`save-button ${className}`}
      onClick={onSave}
      disabled={disabled}
      type="button"
    >
      {label}
    </button>
  );
};

export default SaveButton;
